import React, { useContext } from 'react';
import Modal from 'react-modal';
import styles from './CartResetModal.module.css';
import cartResetIcon from "resources/img/puffu/cartReset.png";
import Inline from 'layouts/container/Inline';
import P from 'components/P';
import Dummy from 'components/Dummy';
import { AnimatePresence, motion } from 'framer-motion';
import HorizontalFlex from 'layouts/flex/HorizontalFlex';
import FlexChild from 'layouts/flex/FlexChild';
import Center from 'layouts/wrapper/Center';
import closeIcon from "resources/img/puffu/close.png";
import { BrowserDetectContext } from 'providers/BrowserEventProvider';

const CartResetModal = ({ isOpen, onRequestClose, onConfirm, onCancel, message, horizontal }) => {
    const { isMobile } = useContext(BrowserDetectContext);

    return (

        <Modal
            isOpen={isOpen}
            onRequestClose={onRequestClose}
            className={horizontal ? styles.modal2 : styles.modal}
            overlayClassName={styles.overlay}
            ariaHideApp={false}
        >
            <div style={{
                position: "absolute",
                top: "5%",
                left: "91%",
                zIndex: 9999,
                cursor: "pointer",
            }} onClick={onCancel}>
                <img src={closeIcon} width={"25px"} style={{ filter: "invert(50%)" }} />
            </div>
            <div className={styles.content}>
                <img src={cartResetIcon} width={"100px"} />
                <Dummy height={"20px"} />
                <Inline>
                    <P font={"Pretendard"} weight={700} size={18}>담은 상품을 </P>
                    <P color={"rgba(254, 83, 31, 1)"} font={"Pretendard"} weight={700} size={18}>모두 취소 </P>
                    <P font={"Pretendard"} weight={700} size={18}>하시겠어요?</P>
                </Inline>
                <Dummy height={"20px"} />
                <div style={{ display: "flex", justifyContent: "center" }}>
                    <div style={{ display: "flex", flexDirection: "row", justifyContent: "center", width: "30%", gap: "30px" }}>
                        <FlexChild justifyContent={"center"}>
                            <div className={styles.confirm} onPointerUp={onConfirm}>
                                <Center>
                                    <P size={18} font={"Pretendard"} weight={700} color={"rgba(254, 83, 31, 1)"}>
                                        확인
                                    </P>
                                </Center>
                            </div>
                        </FlexChild>
                        {/* <FlexChild>
                            <div className={styles.cancel} onClick={onCancel}>
                                <Center>
                                    <P size={18} font={"Pretendard"} weight={700} color={"white"}>
                                        돌아가기
                                    </P>
                                </Center>
                            </div>
                        </FlexChild> */}
                    </div>
                </div>
            </div>
        </Modal >
    );
};

export default CartResetModal;